import React, { useEffect } from 'react';
import KeySingleFeature from './KeySingleFeature/KeySingleFeature';
import gsap from "gsap";

const KeyFeatures = ({ KeyFeaturesData, title = "Key Features" }) => {

    useEffect(() => {
        const processElement = document.querySelector(".process");
        if (processElement) {
            const sections = gsap.utils.toArray(".process__item");

            // Create the scroll animation for sections
            gsap.to(sections, {
                xPercent: -30 * (sections.length - 1),
                ease: "none",
                scrollTrigger: {
                    trigger: processElement,
                    markers: false,
                    scrub: true,
                    pin: true,
                    start: "top top",
                    end: () => "+=" + processElement.offsetWidth,
                },
            });
        }
    }, []);

    return (
        <>
            <section className="features__key__area tw-overflow-hidden">
                <div className='mobile-view tw-p-4'>
                    <div className='tw-container tw-mx-auto'>
                        <div className="section__title section__title-h2 ms-5">
                            <h2 className='tw-text-white'>{title}</h2>
                        </div>
                        <div className="tw-flex tw-flex-wrap tw-gap-4">
                            {KeyFeaturesData.map((item, index) => {
                                return <div key={index} className="tw-flex-1">
                                    <KeySingleFeature icon={item.icon} title={item.title} content={item.content} />
                                </div>
                            })}
                        </div>
                    </div>
                </div>


                <div className="process tw-overflow-hidden">
                    <div className="features__key__area__wrap tw-h-full tw-mx-0 tw-overflow-hidden">
                        <div className="process__item features__key__item__left">
                            <div className="features__content">
                                <div className="section__title section__title-h2 ms-5">
                                    <h2 className='tw-text-white'>{title}</h2>
                                </div>
                            </div>
                        </div>

                        <div className="process__item features__key__item__right">
                            <div className="features__content features__key__content__slide">
                                <div className="tw-flex tw-flex-wrap tw-gap-4">
                                    {KeyFeaturesData.map((item, index) => {
                                        return <div key={index} className="tw-flex-1">
                                            <KeySingleFeature icon={item.icon} title={item.title} content={item.content} />
                                        </div>
                                    })}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
};

export default KeyFeatures;
